// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f9dcc787","453":"dd9433cc"}[chunkId] + ".chunk.js";
};